import React, { useRef, useEffect } from "react";

export default function ScrollIntoView({ children, block = 'center' }) {
    const wrapperRef = useRef(null);

    useEffect(() => {
        if (wrapperRef.current) {
            wrapperRef.current.scrollIntoView({ behavior: 'smooth', block: block })
        }
    }, [wrapperRef, block])

    return (
        <div ref={wrapperRef}>
            {children}
        </div>
    )
}